
import Alert from 'vux/src/components/alert/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XImg from 'vux/src/components/x-img/index.vue'

import XInput from "vux/src/components/x-input/index";
import loadPage from '../../components/loadingPage'
import global from '../../../static/js/global'
export default {
data (){
return {
value:'',
mshow:false,
mur1:false,
show_1:false,
picList:[],
imgList:[],
phones:'',
comnNames:'',
phonems:'',
sayMessage:[],
replayMes:[],
vals:'',
mnId:'',
messageTip:'说点什么',
telePhone:'tel:0000',
alertShow:false,
alertMsg:"",
mands:'',
numbers:'',
picList:[],
datas:{},
mindex:'',
mphone:'',
ns:'',
goodSid:'',
srcm:"https://ss1.bdstatic.com/70cFuXSh_Q1YnxGkpoWK1HF6hhy/it/u=2109543758,1542619281&fm=27&gp=0.jpg",
smc:'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1532413887778&di=4c5590ace460fdd19fcafd9aabe91366&imgtype=0&src=http%3A%2F%2Fpic.58pic.com%2F58pic%2F15%2F57%2F84%2F70H58PICCJt_1024.jpg',
srcs:"https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1532413887778&di=4c5590ace460fdd19fcafd9aabe91366&imgtype=0&src=http%3A%2F%2Fpic.58pic.com%2F58pic%2F15%2F57%2F84%2F70H58PICCJt_1024.jpg"
}
},
components:{
XInput,
XButton,
XHeader,
Alert,
Flexbox,
FlexboxItem,
XImg,
loadPage
},
beforeMount(){
this.phones =this.$router.history.current.query.phone;
this.phonems = this.$router.history.current.query.phones;
this.goodSid = this.$router.history.current.query.goodsId;
this.show_1 = true;
let url = global.host + 'secondMarket/findgoodsDetail?goodsId='+this.$router.history.current.query.goodsId;
this.$http.get(url).then(function(res){
this.datas = res.body.result;
this.telePhone = 'tel:'+this.datas.telePhone;
if(this.datas.imgs.length>0){
for(let mv in this.datas.imgs){
this.datas.imgs[mv].maxPicUrl = global.baseImg+this.datas.imgs[mv].maxPicUrl;
this.picList.push(this.datas.imgs[mv]);
}
}
this.show_1 = false;
},function(err){
console.log(err)
})


this.yesNoCloct();
},
mounted(){

let selfs = this;
$(".am_cloct").click(function(){
if(selfs.ns == "0"){
selfs.qxClocts();
}else if(selfs.ns == "1"){
selfs.syCloct();
}
})

if(this.$router.history.current.path == "/marketDetailList"){
document.title = "商品详情";
}

},
methods:{
onShow(){
this.mur1 = true;
$(".am_bg_content").show();
$('#password1').focus();
this.loadData();
},
noInput(){
this.mur1 = false;
},
yesNoCloct(){//判断是否收藏
let selfs = this;
let url = global.host + 'secondMarket/findcollectinggoods';
let sDta = {
regPhone:this.$router.history.current.query.phones,
sourceId:this.$router.history.current.query.goodsId
};

this.$http.post(url,sDta).then(function(res){
let statCode = res.body.code;
if(statCode == 110){
$(".am_cloct").find(".iconfont").addClass("icon-ai-mark");
this.ns = "0";
}else if(statCode == 120){
$(".am_cloct").find(".iconfont").removeClass("icon-ai-mark");
this.ns = "1";
}
},function(err){
console.log(err)
})
},
syCloct(){//收藏
let selfs = this;
let urls = global.host + 'secondMarket/collectinggoodsinfo';
let surl = this.$router.history.current.fullPath;
let sDta = {
collectDesc:this.datas.goodsName,
collectUrl:surl,
collectType:'oldGoods',
regPhone:this.$router.history.current.query.phones,
sourceId:this.datas.goodsId
};

this.$http.post(urls,sDta).then(function(res){
let statCode = res.body.code;
if(statCode == 110){
this.ns = "0";
$(".am_cloct").find(".iconfont").addClass("icon-ai-mark");
}else if(statCode == 120){
this.ns = "1";
$(".am_cloct").find(".iconfont").removeClass("icon-ai-mark");
}
},function(err){
console.log(err)
})
},
qxClocts(){//取消收藏
let selfs = this;
let urls = global.host + 'secondMarket/cancelgoodsinfo';
let sDta = {
regPhone:this.$router.history.current.query.phones,
sourceId:this.datas.goodsId
};
this.$http.post(urls,sDta).then(function(res){
let statCode = res.body.code;
if(statCode == 110){
this.ns = "1";
$(".am_cloct").find(".iconfont").removeClass("icon-ai-mark");
}else if(statCode == 120){
this.ns = "0";
$(".am_cloct").find(".iconfont").addClass("icon-ai-mark");
}
},function(err){
console.log(err)
})
},
replays(muid,mais){
this.mur1 = true;
this.mindex = "1";
this.vals = "";
if(muid != ''&& muid != null){
this.mnId = muid;
}else{
this.mnId = '';
}
if(mais != ''&& mais != null){
this.mands = mais;
}else{
this.mands = '';
}
this.messageTip = "回复"+mais+"：";
},
sendCont(){//发送留言
if(this.vals.trim()==''){
this.alertShow = true;
this.alertMsg = '留言不能为空';
return;
}
this.mur1 = false;
let url = global.host + 'secondMarket/sendgoodsmessboard';
let surl = this.$router.history.current.fullPath;
let jsonData = {
goodsId:this.datas.goodsId,
message:this.vals,
pushMan:this.datas.contactMan,
regPhone:this.phonems,
parentId:this.mnId,
parentman:this.mands,
noticeType:'oldGoods',
noticeTitle:this.datas.goodsName,
receivePhone:this.datas.mainPhone,
noticeLink:surl,
flag:1
}

this.$http.post(url,jsonData).then(function(res){

this.sayMessage = res.body;
let bdata = res.body;
for(var i=1;i<bdata.length;i++){
this.numbers = i;
}
this.vals = "";
this.show_1 = false;
},function(err){
console.log(err)
})
},
loadData(){//留言列表
this.show_1 = true;
this.mindex = "0";
let url = global.host + 'secondMarket/sendgoodsmessboard';
let jsonData = {
goodsId:this.datas.goodsId,
flag:0
}
this.$http.post(url,jsonData).then(function(res){

this.sayMessage = res.body;
let bdata = res.body;
for(var i=1;i<bdata.length;i++){
this.numbers = i;
}
this.show_1 = false;

setTimeout(function () {
window.scrollTo(0, document.body.scrollHeight+20);
},100);

},function(err){
console.log(err)
})
}
}
}



// WEBPACK FOOTER //
// ./src/components/fleaMarketComponents/marketDetailList.vue